"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _PlayerCache2 = _interopRequireDefault(require("./PlayerCache"));
var _LiveSeekPlayer = _interopRequireDefault(require("./wrappers/LiveSeekPlayer"));
var _InstreamAdPlayer = _interopRequireDefault(require("./wrappers/InstreamAdPlayer"));
var _players = _interopRequireDefault(require("./constants/players"));
var _mediaFormats = _interopRequireDefault(require("./constants/mediaFormats"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-underscore-dangle */
var PlayerLoader = exports["default"] = /*#__PURE__*/function (_PlayerCache) {
  (0, _inherits2["default"])(PlayerLoader, _PlayerCache);
  function PlayerLoader(configuration) {
    var _this;
    (0, _classCallCheck2["default"])(this, PlayerLoader);
    _this = _callSuper(this, PlayerLoader, [configuration]);
    _this.configuration = configuration;
    return _this;
  }

  /**
   * Public method that returns an array of player instances for the
   * given stream.
   *
   * @param stream {Object}
   * @returns {Promise<any[]>}
   */
  (0, _createClass2["default"])(PlayerLoader, [{
    key: "getPlayers",
    value: function getPlayers(stream) {
      var playerPromises = [this._getInstreamAdPlayer(stream), this._getLiveSeekPlayer(stream),
      // Must try HLS.js player first otherwise Safari will always choose native implementation.
      this._getHlsJsPlayer(stream), this._getWebMediaPlayer(), this._getJPlayer(), this._getWindowsMediaPlayer()

      // Don't want player creation errors aborting creation of ALL players.
      ].map(function (promise) {
        return promise && promise["catch"](_noop["default"]);
      });
      return Promise.all(playerPromises).then(function (loadedPlayers) {
        return loadedPlayers.filter(Boolean);
      });
    }
  }, {
    key: "_getInstreamAdPlayer",
    value: function () {
      var _getInstreamAdPlayer2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(stream) {
        var hlsjsPlayer, _this$configuration, timeout, isInstreamLoggingEnabled, tuner;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (stream.isHlsAdvanced) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", null);
            case 2:
              _context.next = 4;
              return this._getPlayerFromCache(_players["default"].hlsjs);
            case 4:
              hlsjsPlayer = _context.sent;
              if (hlsjsPlayer) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", null);
            case 7:
              _this$configuration = this.configuration, timeout = _this$configuration.timeout, isInstreamLoggingEnabled = _this$configuration.isInstreamLoggingEnabled, tuner = _this$configuration.tuner;
              return _context.abrupt("return", new _InstreamAdPlayer["default"](hlsjsPlayer, timeout, isInstreamLoggingEnabled, tuner));
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _getInstreamAdPlayer(_x) {
        return _getInstreamAdPlayer2.apply(this, arguments);
      }
      return _getInstreamAdPlayer;
    }()
  }, {
    key: "_getLiveSeekPlayer",
    value: function () {
      var _getLiveSeekPlayer2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(stream) {
        var hlsjsPlayer;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (stream.isLiveSeekStream) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", null);
            case 2:
              _context2.next = 4;
              return this._getPlayerFromCache(_players["default"].hlsjs);
            case 4:
              hlsjsPlayer = _context2.sent;
              if (hlsjsPlayer) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", null);
            case 7:
              return _context2.abrupt("return", new _LiveSeekPlayer["default"](hlsjsPlayer));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _getLiveSeekPlayer(_x2) {
        return _getLiveSeekPlayer2.apply(this, arguments);
      }
      return _getLiveSeekPlayer;
    }()
  }, {
    key: "_getWebMediaPlayer",
    value: function _getWebMediaPlayer() {
      if (this.configuration.isWebMediaPlayerEnabled) {
        return this._getPlayerFromCache(_players["default"].webmediaplayer);
      }
    }
  }, {
    key: "_getJPlayer",
    value: function _getJPlayer() {
      return this._getPlayerFromCache(_players["default"].jplayer);
    }
  }, {
    key: "_getHlsJsPlayer",
    value: function _getHlsJsPlayer(stream) {
      if (stream.format === _mediaFormats["default"].hls && !this.configuration.hasNativeHlsSupport) {
        return this._getPlayerFromCache(_players["default"].hlsjs);
      }
    }
  }, {
    key: "_getWindowsMediaPlayer",
    value: function _getWindowsMediaPlayer() {
      return this._getPlayerFromCache(_players["default"].wmp);
    }
  }, {
    key: "_getPlayerFromCache",
    value: function () {
      var _getPlayerFromCache2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(playerName) {
        var player;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getPlayer(playerName);
            case 2:
              player = _context3.sent;
              this.setPlayer(playerName);
              return _context3.abrupt("return", player);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _getPlayerFromCache(_x3) {
        return _getPlayerFromCache2.apply(this, arguments);
      }
      return _getPlayerFromCache;
    }()
  }]);
  return PlayerLoader;
}(_PlayerCache2["default"]);
//# sourceMappingURL=PlayerLoader.js.map